var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getPlatform } from '@tujia/fe-lib-common/lib/tj-utils/platform';
import { asyncLoadScript } from '@tujia/fe-lib-common/lib/utils/dom-helper';
import { getChannelInfo } from '@tujia/fe-lib-common/lib/tj-channel';
import * as tjStorage from '@tujia/fe-lib-common/lib/tj-storage';
var WX_SDK_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
var ALI_SDK_URL = 'https://appx/web-view.min.js';
var BAIDU_SDK_URL = 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.8.js';
var TT_SDK_URL = 'https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js';
var TJ_BRIDGE_URL = 'https://pic.tujia.com/upload/festatic/jslibs/fe_bridge-min-v180.js';
var CTRIP_BRIDGE_URL = 'https://pic.tujia.com/upload/festatic/jslibs/cBridge-v1.js';
var QUNAR_BRIDGE_URL = 'https://pic.tujia.com/upload/festatic/jslibs/hysdk-v1312.js';
// const KWAI_BRIDGE_URL =
//   'https://pic.tujia.com/upload/festatic/jslibs/hysdk-v1312.js'
var isAutoInitSdk = false;
export function autoInitSdkByPlatform() {
    return __awaiter(this, void 0, void 0, function () {
        var platformInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    platformInfo = getPlatform();
                    if (!(platformInfo.isWxEnv && !window.wx)) return [3 /*break*/, 2];
                    return [4 /*yield*/, asyncLoadScript(WX_SDK_URL)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 14];
                case 2:
                    if (!((platformInfo.isAliEnv || platformInfo.isGaoDeMpEnv) &&
                        !window.my)) return [3 /*break*/, 4];
                    return [4 /*yield*/, asyncLoadScript(ALI_SDK_URL)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 14];
                case 4:
                    if (!(platformInfo.isBaiduMpEnv && !window.swan)) return [3 /*break*/, 6];
                    return [4 /*yield*/, asyncLoadScript(BAIDU_SDK_URL)];
                case 5:
                    _a.sent();
                    return [3 /*break*/, 14];
                case 6:
                    if (!(platformInfo.isTouTiaoMpEnv && !window.tt)) return [3 /*break*/, 8];
                    return [4 /*yield*/, asyncLoadScript(TT_SDK_URL)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 14];
                case 8:
                    if (!((platformInfo.isTujiaAppEnv || platformInfo.isMayiAppEnv) &&
                        !window.tjBridge)) return [3 /*break*/, 10];
                    return [4 /*yield*/, asyncLoadScript(TJ_BRIDGE_URL)];
                case 9:
                    _a.sent();
                    return [3 /*break*/, 14];
                case 10:
                    if (!(platformInfo.isCtripAppEnv && !window.cbridge)) return [3 /*break*/, 12];
                    return [4 /*yield*/, asyncLoadScript(CTRIP_BRIDGE_URL)];
                case 11:
                    _a.sent();
                    return [3 /*break*/, 14];
                case 12:
                    if (!(platformInfo.isQunarAppEnv && !window.hysdk)) return [3 /*break*/, 14];
                    return [4 /*yield*/, asyncLoadScript(QUNAR_BRIDGE_URL)];
                case 13:
                    _a.sent();
                    _a.label = 14;
                case 14:
                    // else if (platformInfo.isKuaiShouMpEnv && window.ks) {
                    //   await asyncLoadScript(KWAI_BRIDGE_URL)
                    // }
                    isAutoInitSdk = true;
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * 执行SDK初始化后的代码
 * @param params
 */
export function invokeOnBridgeSdkInit(fun) {
    return __awaiter(this, void 0, void 0, function () {
        var platformInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    platformInfo = getPlatform();
                    if (!!isAutoInitSdk) return [3 /*break*/, 2];
                    return [4 /*yield*/, autoInitSdkByPlatform()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!platformInfo.isWxEnv) return [3 /*break*/, 4];
                    return [4 /*yield*/, invokeByWxSDK(fun)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4: return [4 /*yield*/, fun()];
                case 5: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function invokeByWxSDK(fun) {
    return new Promise(function (resolve) {
        // window.WeixinJSBridge
        if (window.wx) {
            resolve(fun());
        }
        else {
            document.addEventListener('WeixinJSBridgeReady', function () { return resolve(fun()); });
        }
    });
}
/**
 * 小程序 帮助类
 */
export var mpUtils = {
    invokeMpFunction: function (funName, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, invokeOnBridgeSdkInit(function () {
                            // 增加调用容错
                            if (!getPlatform().isMpEnv) {
                                return;
                            }
                            else {
                                var fn = mpUtils.getMpSDK()[funName];
                                return fn(data);
                            }
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    postMessage: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, mpUtils.invokeMpFunction('postMessage', data)];
            });
        });
    },
    navigateTo: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, mpUtils.invokeMpFunction('navigateTo', data)];
            });
        });
    },
    switchTab: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, mpUtils.invokeMpFunction('switchTab', data)];
            });
        });
    },
    navigateBack: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, mpUtils.invokeMpFunction('navigateBack', data)];
            });
        });
    },
    redirectTo: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, mpUtils.invokeMpFunction('redirectTo', data)];
            });
        });
    },
    /**
     * 获取小程序SDK对象，包含 信小程序/支付宝小程序/百度小程序/头条小程序/快应用/快手
     */
    getMpSDK: function () {
        var platformInfo = getPlatform();
        var channelInfo = getChannelInfo();
        var mpSDK = window;
        //TTJ-22212 只在c微信使用cmpBridge，在其他小程序里还是使用之前的
        if (platformInfo.isWxEnv &&
            channelInfo.isCtrip &&
            window.cmpBridge &&
            window.isCtripMob) {
            mpSDK = window.cmpBridge;
        }
        else if (platformInfo.isWxEnv && window.wx) {
            mpSDK = window.wx.miniProgram;
        }
        else if ((platformInfo.isAliEnv || platformInfo.isGaoDeMpEnv) &&
            window.my) {
            mpSDK = window.my;
        }
        else if (platformInfo.isBaiduMpEnv && window.swan) {
            mpSDK =
                window.swan && window.swan.webView ? window.swan.webView : window.swan;
        }
        else if (platformInfo.isTouTiaoMpEnv && window.tt) {
            mpSDK = window.tt.miniProgram;
        }
        else if (platformInfo.isQuickMpEnv && window.system) {
            mpSDK = window.system;
        }
        else if (platformInfo.isKuaiShouMpEnv && window.ks) {
            mpSDK = window.ks;
        }
        return mpSDK;
    },
    /**
     * 返回小程序首页
     */
    goMpHomePage: function () {
        var channelInfo = getChannelInfo();
        // 解决切换小程序瞬间，微信 SDK 执行失败
        var failFun = {
            fail: function () {
                setTimeout(function () {
                    mpUtils.goMpHomePage();
                }, 100);
            }
        };
        if (channelInfo.isElong) {
            mpUtils.postMessage({ data: { homeOpt: { tab: 26 } } });
            mpUtils.switchTab(__assign({ url: '/page/home/index/index' }, failFun));
        }
        else if (channelInfo.isCtrip) {
            mpUtils.switchTab(__assign({ url: '/pages/home/homepage' }, failFun));
        }
        else if (channelInfo.isQunar) {
            mpUtils.switchTab(__assign({ url: '/pages/platform/indexWx/index' }, failFun));
        }
        else if (channelInfo.isTujia || channelInfo.isMayi) {
            mpUtils.switchTab(__assign({ url: '/pages/index/index' }, failFun));
        }
    },
    /**
     * 根据当前用户自动检测
     */
    autoCheckMpChannelEnv: function () {
        if (!getPlatform().isMpEnv) {
            return;
        }
        var checkChannel = function () {
            var channelInfo = getChannelInfo();
            var storageChannelId = tjStorage.getChannelId();
            // 判定当前内存的channelId 和 cookie 中的是否一致
            // 修复小程序下使用途家域名导致 channelId 和 登录信息 互串问题
            // 强制跳转到首页
            if (channelInfo &&
                storageChannelId &&
                channelInfo.channelId !== storageChannelId) {
                mpUtils.goMpHomePage();
            }
        };
        window.addEventListener('visibilitychange', function () {
            if (!document.hidden) {
                checkChannel();
            }
        });
    }
};
